<template>
	<div class="home">
		<navbar></navbar>
		<section id="head" class="head row md-whiteframe center-xs middle-xs">
			<div class="gradient"></div>
			<div class="column main">				
				<div class="intro col-md-offset-1 col-md-10 row middle-xs">
					<div class="col-md-7">
						<animated-logo primaryColor="#ffffff" secondaryColor="#2196f3"></animated-logo>
						<!--<h2>{{$t("home.introtitle")}}</h2>-->
						<p v-html="$t('home.intro')"></p>
					</div>
					<div class="col-md-5 col-xs-12" v-if="introLoaded">
						<iframe width="560" height="315" src="https://www.youtube.com/embed/f_MiF80J04M?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</section>

		<section class="row first col-md-offset-1 col-md-10 between-md">
			<md-card>
				<md-card-content>
					<store-links :type="type"></store-links>
				</md-card-content>
			</md-card>
		</section>

		<section class="row col-md-offset-1 col-md-10">
			<md-card>
				<md-card-content class="row features">
					<div class="col-md-7 row">
						<div class="col-sm-6 col-xs-12">
							<img src="../assets/icons/icon-time.png">
							<h3>{{$t("home.featuresecond")}}</h3>
							<p>{{$t("home.featureseconddesc")}}</p>
						</div>
						<div class="col-sm-6 col-xs-12">
							<img src="../assets/icons/icon-graph.png">
							<h3>{{$t("home.featurethird")}}</h3>
							<p>{{$t("home.featurethirddesc")}}</p>
						</div>
						<div class="col-sm-6 col-xs-12">
							<img src="../assets/icons/icon-calendar.png">
							<h3>{{$t("home.featurefourth")}}</h3>
							<p>{{$t("home.featurefourthdesc")}}</p>
						</div>
						<div class="col-sm-6 col-xs-12">
							<img src="../assets/icons/icon-stetho.png">
							<h3>{{$t("home.featurefirst")}}</h3>
							<p>{{$t("home.featurefirstdesc")}}</p>
						</div>
					</div>
					<div class="col-md-5 col-xs-12 row center-xs bottom-xs">
						<div class="intro-mobile">
							<div class="variable" ref="variableA" style="z-index:3;" :style="{'background-image': 'url(' + introImage(0) + ')'}"></div>
							<div class="variable" ref="variableB" style="z-index:2;" :style="{'background-image': 'url(' + introImage(1) + ')'}"></div>
							<div class="variable" ref="variableC" style="z-index:1;" :style="{'background-image': 'url(' + introImage(2) + ')'}"></div>
							<img src="../assets/phone_en_0.jpg">
						</div>
					</div>
				</md-card-content>
			</md-card>
		</section>

		<section class="posts row col-md-offset-1 col-md-10 between-md">
			<feed-view></feed-view>
		</section>

		<section class="row col-md-offset-1 col-md-10">
			<md-card>
				<md-card-header>
					<div class="md-title">{{$t("home.supportTitle")}}</div>
				</md-card-header>
				<md-card-content class="row support">
					<div class="col-sm-3 col-xs-12">
						<a href="http://www.elte.hu" target="_blank">
							<img src="../assets/support/elte.jpg"></br>
							ELTE
						</a>
					</div>
					<div class="col-sm-3 col-xs-12">
						<a href="https://www.eitdigital.eu/eit-digital-academy/" target="_blank">
							<img src="../assets/support/digitalacademy.jpg"></br>
							EIT Digital Academy
						</a>
					</div>
					<div class="col-sm-3 col-xs-12">
						<a href="http://www.ujbuda.hu/" target="_blank">
							<img src="../assets/support/ujbuda.png"></br>
							Újbudai Önkormányzat
						</a>
					</div>
					<div class="col-sm-3 col-xs-12">
						<a href="http://www.szanthoandras.hu/" target="_blank">
							<img src="../assets/support/szanthoestarsa.jpg"></br>
							Szánthó és Társa
						</a>
					</div>
				</md-card-content>
			</md-card>
		</section>

		<!--
		<section class="row col-md-offset-1 col-md-10">
			<md-card>
				<md-card-header>
					<div class="md-title">{{$t("milestones.title")}}</div>
				</md-card-header>
				<md-card-content>
					<milestones></milestones>
				</md-card-content>
			</md-card>
		</section>
		-->

		<section class="team row col-md-offset-1 col-md-10">
			<md-card>
				<md-card-header>
					<div class="md-title">{{$t("contact_us")}}</div>
					<div class="md-subhead">{{$t("report_feedback")}}</div>
				</md-card-header>
				<md-card-content class="center-xs">
					<div class="row center-xs">
						<span v-for="member of team" class="member col-sm-2 col-xs-12">
							<a :href="contactMail()">
								<img :src="teamImgUrl(member.image)">
							</a>
							<br>
							<b>{{member.first}}</b><br>{{member.last}}</br>
							{{$t(member.desc)}}
						</span>
					</div>
					<br>
					<h3>{{$t("home.specialThanks")}}</h3>
					<div class="row center-xs">
						<span v-for="person of thanksFor" class="col-sm-2 col-xs-12">
							<i><b>{{person.first}}</b><br>{{person.last}}</i>
						</span>
					</div>
					<br>
					<div class="row center-xs directly">
						<md-button class="md-primary md-raised" :href="contactMail()">{{$t("contact_us_directly")}} hello@pulmoment.com</md-button>
					</div>
				</md-card-content>
			</md-card>
		</section>


		<section class="row col-md-offset-1 col-md-10 between-md">
			<md-card>
				<md-card-content>
					<store-links :type="type"></store-links>
				</md-card-content>
			</md-card>
		</section>


		<md-dialog ref="videoDialog">
			<md-dialog-content>
				<iframe class="video" width="853" height="480" src="https://www.youtube.com/embed/f_MiF80J04M?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
			</md-dialog-content>
		</md-dialog>

		<section class="footer row col-md-offset-1 col-md-10">
			<img src="../assets/logo_icon_grey.png"></br>
			{{ new Date().getFullYear() }} - Pulmoment - All rights reseverd</br>
			<span>Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0">CC BY 3.0</a></span>
		</section>
	</div>
</template>

<script>

	import Vue from 'vue'
	import Api from '../../generated'
	import AnimatedLogo from './AnimatedLogo'
	import BlogService from '../services/BlogService'
	import _ from 'lodash'
	import downsize from 'downsize'
	import Navbar from './Navbar'
	import StoreLinks from './StoreLinks'
	import Milestones from './Milestones'
	import FeedView from './FeedView'
	import tweenlib from 'tween.js';

	var teamImages = require.context('../assets/team/', false, /\.jpg$/);
	var images = require.context('../assets/', false, /\.jpg$/);

	export default {
		name: 'hello',
		components: {
			AnimatedLogo,
			Navbar,
			StoreLinks,
			Milestones,
			FeedView
		},
		data(){
			return {
				type: 'patient',
				currentIntro: 0,
				tween: undefined,
				introLoaded: false,
				video: this.$refs['videoDialog'],
				team: [
				{
					"last": "Eke",
					"first": "Dániel",
					"desc": "home.titleDaniel",
					"image": "ekedaniel_grad.jpg"
				},
				{
					"last": "Bernáth",
					"first": "Levente",
					"desc": "home.titleLevente",
					"image": "bernathlevente_grad.jpg"
				},
				{
					"last": "Dr. Szánthó",
					"first": "András",
					"desc": "home.titleAndras",
					"image": "szanthoandras_grad.jpg"
				}],
				thanksFor:[
				{
					"last": "Szücs",
					"first": "András",
				},
				{
					"last": "Rákosi",
					"first": "Fanni",
				},
				{ 
					last: "Czár Barna",
					first: "Manó"
				},
				{ 
					last: "Kovács",
					first: "Angelika"
				},
				{ 
					last: "Vass",
					first: "Bálint"
				},
				{ 
					last: "Morvay Pál",
					first: "Tomasz"
				}
				]
			}
		},
		methods: {
			heroImage: function(){
				if(this.type === 'patient'){
					return images('./home-bg-patient.jpg');
				} else {
					return images('./home-bg-doctor.jpg');
				}
			},
			teamImgUrl: function (path) {
				return teamImages('./' + path);
			},
			introImage: function(num) {
				if(this.checkLang() == 'hu'){
					return images('./phone_hu_' + num + '.jpg');
				}else{
					return images('./phone_en_' + num + '.jpg');
				}
			},
			showContact() {
				this.$bus.$emit('showContact', 'contact');
			},
			checkLang(){
				return this.$i18n.locale;
			},
			changeType(type){
				if(this.type == type){
					this.scroll();
				}
				this.type = type;
			},
			contactMail(){
				if(this.checkLang() == 'hu'){
					return "mailto:hello@pulmoment.com?subject=Kapcsolatfelvétel";
				}else{
					return "mailto:hello@pulmoment.com?subject=Contact";
				}
			},
			scroll(){
				var coords = { y: 0 };
				var tween = new tweenlib.Tween(coords)
				.to({ y: 400 }, 1000)
				.onUpdate(() => {
					scrollTo(0, coords.y);
				})
				.easing(tweenlib.Easing.Cubic.Out)
				.start();
			},
			loopIntro(){
				var values = { x: 1 };
				this.tween = new tweenlib.Tween(values)
				.to({ x: 0.0 }, 500)
				.onUpdate(() => {
					let introImages = [this.$refs.variableA, this.$refs.variableB, this.$refs.variableC];
					introImages[this.currentIntro].style.opacity = values.x;

					if(values.x === 0){
						this.currentIntro = (this.currentIntro + 1) % introImages.length;
						let nextIntro = (this.currentIntro + 2) % introImages.length;
						for(let i in introImages){
							let index = (this.currentIntro + i) % introImages.length;
							introImages[index].style.zIndex = (introImages.length - i)
						}
						introImages[nextIntro].style.opacity = 1;
					}
					/*console.log(values.x);*/
				})
				.repeat(Infinity)
				.delay(2000)
				//.yoyo(true)
				.start();
			},
			adClose(type){
				if(type == "ok"){
					this.$router.push('/registration/');
				}
			}
		},
		created(){
			this.loopIntro();
		},
		mounted(){
			this.video = this.$refs['videoDialog'];

			this.$nextTick(() => {
				/*
				if(this.checkLang() == 'hu'){
					this.$refs['adDialog'].open();
				}
				*/
			});

			setTimeout(() => {
				this.introLoaded = true;
			}, 2000);
		},
		destroyed(){
			this.tween.stop();
		}
	}
</script>

<style scoped lang="scss">
	.head{
		text-align: center;
		background-color: #2196f3;
		background-image: url('~../assets/pattern_fixed_transparent.png');
		background-size: 256px;
		position: relative;

		h1 {
			color: white;
		}
		.gradient{
			z-index: 0;
			background: linear-gradient(to right, rgba(33,150,243,1) 0%,rgba(33,150,243,1) 2%,rgba(33,150,243,0) 100%);
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
		}
		.main{
			z-index: 1;
			margin-bottom: 32px;
			margin-top: 16px;
			.intro{
				color: white;
				text-align: justify;
				padding: 0 32px;
			}
			iframe{
				width: 100%;
				height: 300px;
			}
		}
		.head-image{
			background-repeat: no-repeat;
			background-position: right bottom;
			background-size: contain;
			min-height: 500px;
			width: 100%;
		}
	}
	.md-card{
		width: 100%;
		padding: 0;
	}
	.feed{
		margin: -16px;
	}
	.first{
		margin-top: -32px;
	}
	.intro{
		overflow: hidden;
		p {
			font-size: 14pt;
			line-height: 20pt;
		}
	}
	.md-card-content.row.intro{
		padding-bottom: 0;
	}
	.md-card-content.row.features{
		padding-bottom: 0;
	}
	.intro-mobile{
		position: relative;
		overflow: hidden;
		
		img {
			margin-bottom: -23px;
			opacity: 0;		
		}
		.variable{
			width: 100%;
			height: 100%;
			position: absolute;
			background-repeat: no-repeat;
			background-position: center;
			background-size: contain;

			-webkit-backface-visibility: hidden;
			-moz-backface-visibility:    hidden;
			-ms-backface-visibility:     hidden;
		}
	}
	section{
		margin-bottom: 16px;
	}

	.support{
		text-align: center;
		img{
			height: 120px;
		}
	}

	.team{
		.member{
			text-align: center;
			cursor: pointer;
			img{
				height: 120px;
				border-radius: 32px;
				transition: box-shadow 0.3s;
			}
			&:hover{
				img{
					box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
				}
			}
		}
		.directly{
			margin: 16px;
		}
	}

	.footer{
		text-align: center;
		display: block;
		padding: 16px 0;
		img{
			height: 25px;
		}
	}

	.video{
		height: 480px;
	}

</style>



// WEBPACK FOOTER //
// Home.vue?d71ecf9c